import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import RespondentFlowApi from "../services/respondentFlow.api";
import LoggerService from "../services/logger.service";
import { SCREENER_ROUTE, ERROR_ROUTE } from "../constants/routes.constants";
import FinSurveyPng from "../assests/magnifying-glass-icon.gif";
import {
  SURVEY_SCREENER_FAILED_SUPPLIER_REDIRECT,
  SURVEY_SCREENER_NOT_REQUIRED,
  SURVEY_SCREENER_PASSED,
  SURVEY_SCREENING,
  SURVEY_SCREENING_FAILED_RESET_QUES,
  SURVEY_SCREENER_PASSED_CLIENT_REDIRECT,
} from "../constants/event.constants";
import environment from "../environments/environment.json";
import { Backdrop, CircularProgress, TextField } from "@mui/material";
import { BounceLoader, ClipLoader } from "react-spinners";
import axios from "axios";
import { sessionStore } from "../services/storage.service";
import { windowLocation, windowLocationRelayed } from "../services/redirect.service";

const Start = () => {
  const [Loader, setLoader] = useState(true);
  const [ErrorMessage] = useState("");
  const [idx, setIdx] = useState(0);
  const [obj, setObj] = useState({});
  const [match, setMatch] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [errorIndex, setErrorIndex] = useState("");
  const [questions, setQuestions] = useState([]);
  // const [sessionParams, setSessionParams] = useState(null);
  const [surveyId, setSurveyId] = useState(undefined);

  let navigate = useNavigate();

  function getQueryParams() {
    const params = {};
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.forEach((value, key) => {
      params[key] = value;
    });
    return params;
  }

  const rdBaseUrl = environment.RD_BASE_URL + environment.RD_PUBLISHABLE_KEY;

  let getRDToken = async (userId,storedParam) => {
    try {
      
      let rdUrl = `${rdBaseUrl}?tokens=1&rt_sr_pd=${userId}`;
      LoggerService.log(
        storedParam.token ?? "",
        storedParam.vendorToken ?? "",
        "Sending RD Get Token Request",
        rdUrl,
        storedParam.campaignUid
      );
      let { data, status } = await axios.get(rdUrl, {
        "User-Agent": navigator.userAgent,
        timeout: 10000,
      });
      if (status !== 200) {
        LoggerService.log(
          storedParam.token ?? "",
          storedParam.vendorToken ?? "",
          "Failed to get RD Get Tokens",
          status,
          storedParam.campaignUid
        );
        return null;
      }

    return data.results;
  } catch (e) {
    LoggerService.log(
      storedParam.token ?? "",
      storedParam.vendorToken ?? "",
      "Failed to get RD Get Tokens",
      e.message,
      storedParam.campaignUid
    );
    return null;
  }
  };

  let getDynamicProfiling = async () => {
    setLoader(true);
    let storedParam = JSON.parse(sessionStore.getItem("params"));
    if(!storedParam) {
      const queryParams = getQueryParams();
      storedParam = queryParams;
    }
    try {
      let reqObj = {};
      reqObj.token = storedParam.token;
      reqObj.userId = storedParam.userId;
      reqObj.paramList = storedParam.paramList;
      reqObj.newToken = storedParam.isEnding ? storedParam.isEnding : false;
      if (reqObj.newToken) {
        reqObj.allSurveys = false;
      } else {
        reqObj.allSurveys = true;
      }

      let securityConfig = await RespondentFlowApi.post("/v1/profiling/security/config", {token:reqObj.token});
      if(securityConfig.rdEnable) {
        let rdResp = await getRDToken(storedParam.userId,storedParam);
        if (rdResp) {
          reqObj.rdToken = rdResp.map((obj) =>{ return obj.token});
        }
      }

      LoggerService.log(
        storedParam.token ?? "",
        storedParam.vendorToken ?? "",
        "Sending Router Request",
        JSON.stringify(reqObj),
        storedParam.campaignUid
      );

      let resp = await RespondentFlowApi.post("/v1/profiling/dynamic", reqObj);
      LoggerService.log(
        storedParam.token ?? "",
        storedParam.vendorToken ?? "",
        "Router Response received",
        JSON.stringify(resp),
        storedParam.campaignUid
      );
      // if (resp.isInternalRedirect) {
      let obj = {};
      obj.eventType = resp.eventType;
      obj.token = resp.token;
      obj.userId = resp.userId;
      obj.questionList = resp.questionList;
      //TODO:: get campaignUid from params

      if (obj.eventType == SURVEY_SCREENING) {
        LoggerService.log(
          resp.token,
          storedParam.vendorToken ?? "",
          "Router survey received(" +
            resp.surveyId +
            "), Dynamic Profiling started(partial_match)",
          JSON.stringify(resp),
          storedParam.campaignUid ?? ""
        );
        let questionText =
          resp.questionList.length > 0 ? resp.questionList[0].text : "";

        LoggerService.log(
          resp.token,
          storedParam.vendorToken ?? "",
          "Dynamic Profiling(" +
            resp.surveyId +
            ") Displaying the 1st question " +
            questionText,
          JSON.stringify(resp),
          storedParam.campaignUid ?? ""
        );
        setQuestions(resp.questionList);
        setSurveyId(resp.surveyId);
        setLoader(false);
      } else if (obj.eventType == SURVEY_SCREENER_PASSED_CLIENT_REDIRECT) {
        await LoggerService.log(
          resp.token,
          storedParam.vendorToken ?? "",
          "Router response received, Redirecting to client(exact_match)",
          `${resp.redirectUrl}`,
          storedParam.campaignUid ?? ""
        );

        sessionStore.removeItem("params");
        windowLocationRelayed(resp.redirectUrl,resp.token, "client");
        // window.location.href = `${resp.redirectUrl}`;
        setLoader(true);
      } else if (obj.eventType == SURVEY_SCREENER_FAILED_SUPPLIER_REDIRECT) {
        setLoader(true);
        await LoggerService.log(
          resp.token,
          storedParam.vendorToken ?? "",
          "Router response received, Redirecting to supplier(no_match)",
          `${resp.redirectUrl}`,
          storedParam.campaignUid ?? ""
        );
        sessionStore.removeItem("params");
        //TODO:: redirect via
        windowLocationRelayed(resp.redirectUrl,resp.token);
        // window.location.href = `${resp.redirectUrl}`;
      }
    } catch (e) {
      sessionStore.removeItem("params");
      LoggerService.log(
        storedParam?.token ?? "",
        "",
        "Router response received, redirecting to error(error)" + e.message
      );
      navigate(ERROR_ROUTE);
    }
  };

  useEffect(() => {
    getDynamicProfiling();
  }, []);

  let saveRsponse = async (event) => {
    let params = sessionStore.getItem("params");
    let paramObj = JSON.parse(params);
    if(!paramObj) {
      const queryParams = getQueryParams();
      paramObj = queryParams;
    }
    event.preventDefault();
    if (errorIndex === "") {
      setIsLoading(true);
      let reqObj = {};
      reqObj.userId = paramObj.userId;
      reqObj.token = paramObj.token;
      reqObj.surveyId = surveyId;
      reqObj.newToken = paramObj.isEnding ? paramObj.isEnding : false;
      reqObj.responses = [
        {
          id: obj.id,
          answerText: obj.answerText,
          answerId: obj.answerId,
        },
      ];
      if (questions.length - 1 === idx) {
        reqObj.isLastQuestion = true;
      } else {
        reqObj.isLastQuestion = false;
      }
      let dbquestionText = obj.text ?? "";
      LoggerService.log(
        paramObj.token ?? "",
        paramObj.vendorToken ?? "",
        `Saving ${idx + 1}  dynamic profiling question - ${dbquestionText}`,
        JSON.stringify(reqObj),
        paramObj.campaignUid ?? ""
      );

      try {
        let response = await RespondentFlowApi.post(
          `/v1/profiling/d/response`,
          reqObj
        );

        if (response.status === false) {
          LoggerService.log(
            response.token,
            paramObj.vendorToken ?? "",
            "Qualification terminated",
            JSON.stringify(response),
            paramObj.campaignUid ?? ""
          );
          if (response.eventType === SURVEY_SCREENING) {
            LoggerService.log(
              response.token,
              paramObj.vendorToken ?? "",
              "New Router survey " +
                response.surveyId +
                " received, Dynamic Profiling started(partial_match)",
              JSON.stringify(response),
              paramObj.campaignUid ?? ""
            );

            let questionText =
              response.questionList.length > 0
                ? response.questionList[0].text
                : "";
            //
            LoggerService.log(
              response.token,
              paramObj.vendorToken ?? "",
              "Dynamic Profiling(" +
                response.surveyId +
                ") Displaying the 1st question" +
                questionText,
              JSON.stringify(response),
              paramObj.campaignUid ?? ""
            );
            setQuestions(response.questionList);
            setSurveyId(response.surveyId);
            setIdx(0);
            setErrorIndex("");
            setMatch(true);
            setIsLoading(false);
          } else if (
            response.eventType === SURVEY_SCREENER_FAILED_SUPPLIER_REDIRECT
          ) {
            setIsLoading(true);
            LoggerService.log(
              response.token,
              paramObj.vendorToken ?? "",
              "Dynamic Profiling(no_survey), Redirecting to supplier(no_match)",
              `${response.redirectUrl}`,
              paramObj.campaignUid ?? ""
            );
            sessionStore.removeItem("params");
            windowLocationRelayed(response.redirectUrl,response.token);
            // window.location.href = `${response.redirectUrl}`;
          }
        } else {
          if (response.eventType === SURVEY_SCREENING) {
            // is Last question

            if (questions.length - 1 === idx) {
            } else {
              let questionText = questions[idx + 1]?.text ?? "";
              LoggerService.log(
                response.token,
                paramObj.vendorToken ?? "",
                `Dynamic Profiling(${reqObj.surveyId}) Displaying the ${
                  idx + 1
                } question - ${questionText}`,
                JSON.stringify(response),
                paramObj.campaignUid ?? ""
              );
              setErrorIndex("");
              setIdx(idx + 1);
              setMatch(true);
              setIsLoading(false);
            }
          } else if (
            response.eventType === SURVEY_SCREENER_PASSED_CLIENT_REDIRECT
          ) {
            LoggerService.log(
              response.token,
              paramObj.vendorToken ?? "",
              "Dynamic Profiling (" +
                response.surveyId +
                ") Completed, redirecting to client(partial_match)",
              `${response.redirectUrl}`,
              paramObj.campaignUid ?? ""
            );
            windowLocationRelayed(response.redirectUrl,response.token,"client");
            // window.location.href = `${response.redirectUrl}`;
          }
        }
      } catch (e) {
        console.error(e);
        LoggerService.log(
          paramObj.token ?? "",
          paramObj.vendorToken ?? "",
          "error in saving response " + JSON.stringify(e),
          "",
          paramObj.campaignUid ?? ""
        );
        setIsLoading(false);
        navigate(ERROR_ROUTE);
      } finally {
        setIsLoading(false);
      }
    }
  };

  useEffect(() => {
    if (questions.length > 0 && questions[idx]) {
      setObj(JSON.parse(JSON.stringify(questions[idx])));
    }
    // eslint-disable-next-line
  }, [questions, idx]);

  useEffect(() => {
    if (obj.type === 3 || obj.type === 4) {
      if (
        !obj?.answerText ||
        obj?.answerText === null ||
        obj?.answerText === "" ||
        (obj.id === 59 && obj?.answerText > 99)
      ) {
        setErrorIndex(obj.id);
      } else {
        setErrorIndex("");
      }
    } else {
      if (!obj?.answerId || obj?.answerId?.length === 0) {
        setErrorIndex(obj.id);
      } else {
        setErrorIndex("");
      }
    }

    // eslint-disable-next-line
  }, [obj]);

  const responsequestions = (e) => {
    e.preventDefault();
  };
  return (
    <div>
      {Loader || isLoading ? (
        <div className="flex flex-col items-center justify-center h-screen bg-gray-200">
          <ClipLoader color="#f00" loading={true} size={80} />
        </div>
      ) : (
        <div className="bg-gray-200  h-[100vh] flex justify-center items-center">
          <div className="questionCard ">
            <form
              onSubmit={Loader ? responsequestions : saveRsponse}
              noValidate
              className="h-[100%] relative"
            >
              <div className="question-body ">
                <h1 className="question-text">{questions[idx]?.text}</h1>
                <div className="mb-10">
                  {(questions.length > 0 &&
                    questions[idx] &&
                    questions[idx] &&
                    questions[idx].type === 4) ||
                  (questions.length > 0 &&
                    questions[idx] &&
                    questions[idx] &&
                    questions[idx].type === 3) ? (
                    // change here
                    <div className="mt-2">
                      <TextField
                        size="small"
                        variant="outlined"
                        type="text"
                        className="font-medium text-sm border-2 border-black"
                        value={obj?.answerText}
                        onChange={(e) => {
                          let payload = { ...obj };
                          payload.answerText = e.target.value;
                          setObj(JSON.parse(JSON.stringify(payload)));
                        }}
                        error={
                          !match && errorIndex === questions[idx]?.id
                            ? true
                            : false
                        }
                      />

                      {!match && errorIndex === questions[idx]?.id && (
                        <div
                          style={{
                            color: "red",
                            marginTop: "5px",
                            fontSize: "13px",
                          }}
                        >
                          {obj.answerText > 99
                            ? "This value not be greater then 100 and"
                            : "This field is required!"}
                        </div>
                      )}
                    </div>
                  ) : questions.length > 0 &&
                    questions[idx] &&
                    questions[idx].type === 1 ? (
                    <>
                      {!match && errorIndex === questions[idx]?.id && (
                        <div
                          style={{
                            color: "red",
                            fontSize: "13px",
                          }}
                        >
                          This field is required!
                        </div>
                      )}
                      <div
                        className={
                          questions[idx]?.options.length > 12
                            ? "grid md:grid-cols-2 gap-1 grid-cols-1 "
                            : "grid md:grid-cols-1 gap-1 grid-cols-1 "
                        }
                      >
                        {questions.length > 0 &&
                          questions[idx].options.map((item, i) => {
                            return (
                              <label key={i} className={"radio-option"}>
                                <input
                                  type="radio"
                                  id={`radio_${item.id}`}
                                  name={obj?.id}
                                  checked={obj?.answerId?.includes(item.id)}
                                  onChange={(e, value) => {
                                    let payload = { ...obj };
                                    if (e.target.checked) {
                                      payload.answerId = [item.id];
                                    } else {
                                    }
                                    setObj(JSON.parse(JSON.stringify(payload)));
                                  }}
                                  className="radio-option__input"
                                />
                                <span
                                  className={"radio-option__custom-radio"}
                                ></span>
                                <span className="radio-option__label">
                                  {item?.text}
                                </span>
                              </label>
                            );
                          })}
                      </div>
                    </>
                  ) : (
                    <>
                      {!match && errorIndex === questions[idx]?.id && (
                        <div
                          style={{
                            color: "red",
                            fontSize: "13px",
                          }}
                        >
                          This field is required!
                        </div>
                      )}

                      <div
                        className={
                          questions[idx]?.options.length > 12
                            ? "grid md:grid-cols-2 gap-1 grid-cols-1"
                            : "grid md:grid-cols-1 gap-1 grid-cols-1"
                        }
                      >
                        {questions.length > 0 &&
                          questions[idx] &&
                          questions[idx].options.map((item, id) => {
                            return (
                              <label key={id} className={"input-checkmark"}>
                                <input
                                  type="checkbox"
                                  id={`checkbox_${item.id}`}
                                  name={obj?.id}
                                  checked={obj?.answerId?.includes(item.id)}
                                  onChange={(e, value) => {
                                    let payload = { ...obj };
                                    if (!e.target.checked) {
                                      payload.answerId =
                                        payload.answerId.filter(
                                          (answer) => answer !== item.id
                                        );
                                    } else {
                                      if(payload.answerId && Array.isArray(payload.answerId)) {
                                        payload.answerId.push(item.id);
                                      } else {
                                        payload.answerId = [];
                                        payload.answerId.push(item.id);
                                      }
                                    }
                                    setObj(JSON.parse(JSON.stringify(payload)));
                                  }}
                                />
                                <span className={"checkmark"}></span>
                                <span className="radio-option__label">
                                  {item?.text}
                                </span>
                              </label>
                            );
                          })}
                      </div>
                    </>
                  )}
                </div>
              </div>
              <div className="footer-paading flex flex-row-reverse w-full md:w-[100%] gap-5 h-fit	pb-4 bg-white absolute bottom-0">
                <button
                  className="button"
                  onClick={() => {
                    setMatch(false);
                  }}
                >
                  Next
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Start;
